import $ from 'jquery';

export default {
	getAll(data = { apenasDisponiveis: false, apenasMeus: false }) {
		return $.ajax(Config.BASE_URL + '/agenda', { data });
	},

	getMeusAgendamentos(data = { apenasDisponiveis: false, apenasMeus: true }) {
		return $.ajax(Config.BASE_URL + '/agenda', { data });
	},

	getAssuntosAgendamento(params = {}) {
		return $.ajax(Config.BASE_URL + '/agenda/assuntoAgendamento', params);
	},

	cancelarAgendamento(idAgendamento, params = {}) {
		params.method = 'DELETE';

		return $.ajax(`${Config.BASE_URL}/agenda/${idAgendamento}`, params);
	},

	municipePodeAgendar(params = {}) {
		return $.ajax(`${Config.BASE_URL}/agenda/situacaoAgendamento`, params);
	}
};


// WEBPACK FOOTER //
// ./application/models/agenda.js